module.exports = __webpack_public_path__ + "img/export_icon.d7bdeac8.svg";